export function getCalendarWeeks(viewMonth) {
  const firstOfMonth = viewMonth.clone().startOf('month');
  const startOffset = firstOfMonth.day();
  const cursor = firstOfMonth.clone().subtract(startOffset, 'days');
  const weeks = [];
  for (let w = 0; w < 6; w += 1) {
    const row = [];
    for (let d = 0; d < 7; d += 1) {
      row.push(cursor.clone());
      cursor.add(1, 'day');
    }
    weeks.push(row);
  }
  return weeks;
}

export function isSameCalendarDay(a, b) {
  if (!a || !b) return false;
  return a.isSame(b, 'day');
}

export function isInViewMonth(day, viewMonth) {
  return day.month() === viewMonth.month() && day.year() === viewMonth.year();
}

export function isDayAfterMax(day, maxDate) {
  if (!maxDate) return false;
  return day.isAfter(maxDate, 'day');
}
